import { render, staticRenderFns } from "./InspectionView.vue?vue&type=template&id=42e1d6c7&scoped=true"
import script from "./InspectionView.ts?vue&type=script&lang=ts&external"
export * from "./InspectionView.ts?vue&type=script&lang=ts&external"
import style0 from "./InspectionView.scss?vue&type=style&index=0&id=42e1d6c7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1d6c7",
  null
  
)

export default component.exports